import { createResizeObserver, cleanupResizeObserver } from '@js/vue/directives/utils/calc-dimension-observer.js';

export default {
	mounted(el, binding) {
		const config = typeof binding.value === 'object'
			? binding.value
			: { var: binding.value };

		const varName = config.var || 'height';

		let target;
		if (config.self) {
			target = el;
		} else if (config.target) {
			target = typeof config.target === 'string'
				? el.closest(config.target)
				: config.target;
		} else {
			target = document.documentElement;
		}

		createResizeObserver(el, varName, (element) => element.offsetHeight, target);
	},

	beforeUnmount(el) {
		// Clean up observer when element is removed
		if (el._resizeObserver) {
			el._resizeObserver.disconnect();
			delete el._resizeObserver;
		}
	}
};
